/*
 * EnviAir — Embed auto-resize
 *
 * Zoho Forms posts its rendered height to the parent window when the embed URL
 * carries zf_rszfm=1. The message is a plain string of the form
 * "<formperma>|<height>". This listens for it and grows the matching iframe, so
 * the form is never scrolled inside a fixed-height box.
 *
 * Without this the CSS height from the section settings simply stands.
 */
(function () {
  var SELECTOR = 'iframe[data-ea-embed-autoresize]';

  function frames() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  window.addEventListener(
    'message',
    function (event) {
      var data = event.data;

      // Zoho sends a string; anything else is another embed's traffic.
      if (typeof data !== 'string') return;

      // A third "scroll" part arrives when the form moves to a new page or
      // shows an error, asking for the form to be brought back into view.
      var parts = data.split('|');
      if (parts.length !== 2 && parts.length !== 3) return;

      var perma = parts[0];
      var height = parseInt(parts[1], 10);
      var scroll = parts[2] === 'scroll';

      if (!perma || !height || isNaN(height)) return;

      frames().forEach(function (frame) {
        var src = frame.getAttribute('src') || '';

        // Only resize the frame the message actually came from: several embeds
        // can share a page, and the permalink is what tells them apart.
        if (src.indexOf('formperma') === -1 || src.indexOf(perma) === -1) return;

        var next = height + 'px';
        if (frame.style.height !== next) {
          frame.style.height = next;
        }

        if (scroll) {
          frame.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
    },
    false
  );
})();
